import React from 'react'

export default function About() {

  return (
    <div className='flex flex-col items-center gap-5'><h1 className='text-[200%] font-dmsans text-titles md:text-[260%]'>Sobre mim</h1>
        <h2 className='text-center m-5 text-content  dmsans mx-40 sm:mx-10 sm:m-0 w-[50%] sm:w-[80%] md:m-0 md:text-3xl md:w-[90%] '>Desenvolvedor Front-end com experiência em React.js, JavaScript, TypeScrpt, Context, Redux, Styled Components, Tailwind, docker, testes automatizados e consumo de APIs REST. Apaixonado pelo desenvolvimento de componentes reutilizáveis. Também possuo experiência em projetos gerenciados por Metodologias Ágeis como Scrum e Kanban. Formado em Desenvolvimento Full Stack na Trybe(www.betrybe.com).</h2></div>

          
  )
}
